import {createApp, getCurrentInstance} from 'vue';
import {createPinia} from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import translation from './plugin/translation.ts';
import formatNumbers from './plugin/formatNumbers.ts';
import {shoppingCartStore} from '../components/Store.ts';

window.App = {
    lang: import.meta.env.VITE_LOCALE ?? 'nl',
};

window.locale = 'nl-NL';

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp({
    beforeMount() {
        window.currentInstance = getCurrentInstance();
    },

    mounted() {
        window.modal = window.currentInstance.proxy.$refs.addedProductModal;
    },
});
// app.config.warnHandler = function (msg, vm, trace) {
//     return null
// }
// Dynamisch alle componenten laden uit de `components` map met Vite
const modules = import.meta.glob('/resources/assets/components/**/*.vue', {eager: true});

function configure(vueApp) {
    Object.entries(modules).forEach(([path, component]) => {
        // Extract component name from file path
        const componentName = path.split('/').pop().replace('.vue', '');
        vueApp.component(componentName, component.default);
    });

    vueApp.config.compilerOptions.isCustomElement = (tag) => {
        return tag.startsWith('center');
    };

    vueApp.use(pinia);
    vueApp.use(translation, {lang: window.App.lang});
    vueApp.use(formatNumbers, {lang: window.App.lang});

    return vueApp;
}

// The list page's filter reload replaces #mainContent with jQuery, so whatever owns it must be
// unmountable: an app of its own (an island), never the root app. Left to the root app, the
// components in it (chat, compare bar) lost their HTML but kept running on the shared pinia -
// a comparison opened in the detached chat where nobody saw it, the compare bar threw on every
// redraw. The root app mounts without it; it is mounted as an island right after.
const mainContent = document.getElementById('mainContent');
const mainContentHtml = mainContent?.innerHTML ?? '';
if (mainContent) mainContent.innerHTML = '';

configure(app).mount('#app');
window.store = shoppingCartStore();

// Each swap gets its own app on the replaced container, sharing the same pinia.
const islands = new WeakMap();

window.unmountVueIsland = (el) => {
    islands.get(el)?.unmount();
    islands.delete(el);
};

window.mountVueIsland = (el) => {
    window.unmountVueIsland(el);
    const island = configure(createApp({}));
    island.mount(el);
    islands.set(el, island);
};

// The root app rendered #mainContent empty; its content becomes the first island, so the
// filter reload's unmountVueIsland() always unmounts the components it is about to replace.
// The root mount replaced the element itself, so it is looked up again.
const renderedMainContent = document.getElementById('mainContent');
if (renderedMainContent) {
    renderedMainContent.innerHTML = mainContentHtml;
    window.mountVueIsland(renderedMainContent);
}
